export default __webpack_public_path__ + "static/media/user-17.779972af.jpg";